var render = function render(){var _vm=this,_c=_vm._self._c;return _c('JsonViewer',_vm._b({attrs:{"value":_vm.value || {}}},'JsonViewer',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }